(function () {
  const yearlyOverviewReport = function () {
    const init = () => {
      const MONTH_NAMES = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      const BASIC_CONFIG = {
        type: "line",
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: "bottom",
            },
          },
        },
      };

      const data = {
        labels: MONTH_NAMES,
        datasets: gon.report_data_overview.datasets,
      };

      new Chart(document.getElementById("overview-chart-container"), {
        ...BASIC_CONFIG,
        data: data,
      });

      const greenGrassData = {
        labels: MONTH_NAMES,
        datasets: gon.report_data_green_grass.datasets,
      };

      console.log(greenGrassData);

      new Chart(document.getElementById("green-grass-chart-container"), {
        ...BASIC_CONFIG,
        data: greenGrassData,
      });
    };

    $(document).on("turbolinks:load", () => {
      if (
        $("body").hasClass("controller-dashboards-admin") &&
        $("body").hasClass("action-yearly_overview")
      )
        setTimeout(init, 1000);
    });
  };

  if (typeof window !== "undefined") {
    window.yearlyOverviewReport = yearlyOverviewReport();
  }

  return yearlyOverviewReport;
})();
